import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function SRVTableDisabledMessage({
  message
}) {
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "empty-state-charts",
    children: message
  });
}